export type FocusRingIntent =
  | 'default'
  | 'strong'
  | 'danger'
  | 'success'
  | 'ai'
  | 'inset'
  | 'insetDanger';

const SHADOW_TOKEN: Record<FocusRingIntent, string> = {
  default: 'focus',
  strong: 'focusStrong',
  danger: 'focusDanger',
  success: 'focusSuccess',
  ai: 'focusAi',
  inset: 'focusInset',
  insetDanger: 'focusInsetDanger',
};

/** `_focusVisible`-style halo, intent-matched to the design system's focus shadow tokens. */
export function focusRing(intent: FocusRingIntent = 'default') {
  return {
    outline: 'none',
    boxShadow: SHADOW_TOKEN[intent],
  };
}
